export default __webpack_public_path__ + "static/androi-f90c29691987577436036aacbd5488fc.png";